import React from "react";
import styles from "./Boton.module.css";
import * as Imagenes from "../Iconos.js";

const BotonAceptar = (props) => {
  const estilo = props.estilo;
  const onClick = props.onClick;

  return (
    <button className={`${styles.botonTransparente} ${estilo}`} onClick={onClick}>
      <img
        src={Imagenes.aceptar}
        width="15px"
        height="15px"
        alt="Aceptar"
      />
    </button>
  );
};

export default BotonAceptar;
